import {
  getMapDefinition,
  type MapRuntimeDefinition,
} from "@ninja/game-content";

export interface MapTransitionMarker {
  accessId: string;
  x: number;
  y: number;
  title: string;
  detail: string;
  destinationMapId: string;
}

export function mapTransitionMarkersFor(
  map: MapRuntimeDefinition,
): MapTransitionMarker[] {
  const navigation = map.regionNavigation;
  if (!navigation) return [];

  return (map.regionSpatial?.layers.zone_access ?? []).flatMap((access) => {
    const { accessId, policy, toMapId, spawnId } = access.properties;
    if (
      policy !== "OPEN" ||
      typeof accessId !== "string" ||
      typeof toMapId !== "string" ||
      toMapId === map.id ||
      typeof spawnId !== "string"
    )
      return [];

    const destination = getMapDefinition(toMapId);
    const destinationNavigation = destination?.regionNavigation;
    if (
      !destination ||
      !destinationNavigation ||
      destinationNavigation.regionId !== navigation.regionId
    )
      return [];

    return [
      {
        accessId,
        x: access.x + access.width / 2,
        y: access.y + access.height / 2,
        title: destinationTitle(navigation, destinationNavigation),
        detail: destinationDetail(destinationNavigation),
        destinationMapId: toMapId,
      },
    ];
  });
}

function destinationTitle(
  current: NonNullable<MapRuntimeDefinition["regionNavigation"]>,
  destination: NonNullable<MapRuntimeDefinition["regionNavigation"]>,
): string {
  if (current.role === "boss_arena") return "EXIT BOSS ARENA";
  if (destination.role === "boss_arena") return "ENTER BOSS ARENA";
  return destination.floorIndex > current.floorIndex
    ? "ENTER NEXT AREA"
    : "RETURN TO PREVIOUS AREA";
}

function destinationDetail(
  destination: NonNullable<MapRuntimeDefinition["regionNavigation"]>,
): string {
  if (destination.role === "boss_arena") return "CROSS TO BOSS ARENA";
  return `AREA ${destination.floorIndex} / ${destination.floorCount}`;
}
